var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoWaiting = function SvgNoWaiting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C115.39 0 0 115.39 0 256s115.39 256 256 256 256-115.39 256-256S396.61 0 256 0M97.108 368.954C73.48 335.805 61 296.737 61 256c0-107.52 87.48-195 195-195 40.737 0 79.805 12.48 112.954 36.108a15 15 0 0 1 1.886 1.625L98.733 370.841a15 15 0 0 1-1.625-1.887M256 451c-40.737 0-79.805-12.48-112.954-36.108a15 15 0 0 1-1.886-1.625l272.105-272.105a15 15 0 0 1 1.626 1.885C438.52 176.195 451 215.263 451 256c0 107.52-87.48 195-195 195"
  })));
};
export default SvgNoWaiting;